module.exports = __webpack_public_path__ + "static/media/Road_Condition_Logov3.6568e1cb.jpg";